<template>
  <div class="app-image-upload" style="position: relative">
    <div
      v-if="disabled && currentFileType == 'pag'"
      class="transparent-bg"
    ></div>
    <div>
      <div class="avatar-uploader" :style="sliderStyle" @click="choseFile">
        <div
          v-if="
            imageUrl && !showProgress && !error_img && currentFileType != 'pag'
          "
          class="upload-img-operate"
          @click="choseFile1($event)"
        >
          <div>
            <BrowseIcon
              size="20px"
              @click="showDetail"
              style="color: white; z-index: 100"
            /><t-divider layout="vertical" v-if="showDelete" /><DeleteIcon
              style="color: white"
              size="20px"
              @click="imageUrl = ''"
              v-if="showDelete"
            /><t-divider
              layout="vertical"
              v-if="showEdit && currentFileType == 'image'"
            /><Edit1Icon
              style="color: white"
              size="20px"
              @click="changeImageUrl"
              v-if="showEdit && currentFileType == 'image'"
            />
          </div>
        </div>
        <div
          style="width: 100%; height: 100%; justify-content: center"
          class="flex-align-center"
        >
          <show-progress
            v-if="showProgress"
            :dataName="upload_name"
            style="width: 100px"
          ></show-progress>

          <div v-show="imageUrl" style="width: 100%; height: 100%">
            <video
              style="object-fit: fill; width: 100%; height: 100%"
              v-if="currentFileType == 'video' && !showProgress"
              controls="controls"
              :src="imageUrl"
            ></video>
            <img
              v-if="currentFileType == 'image' && !showProgress"
              :src="imageUrl"
              class="object-fit-cover"
            />
            <canvas
              v-show="currentFileType == 'pag' && !showProgress"
              class="canvas"
              :id="pagID"
            ></canvas>
          </div>

          <i
            v-if="!imageUrl && !showProgress"
            class="el-icon-plus avatar-uploader-icon"
          ></i>
        </div>
      </div>
      <!-- 添加删除按钮 -->
      <!-- <i
        v-if="isShowDel && imageUrl"
        class="el-icon-delete"
        :style="`
          position: absolute;
          top: 1px;
          left: ${Number(sliderStyle.width.replace('px', '')) - 33}px;
          line-height: normal;
          font-size: 20px;
          cursor: pointer;
          display: block;
          background: #000;
          opacity: 0.6;
          color: #fff;
          border-radius: 0 3px 0 50%;
          width: 32px;
          height: 32px;
          line-height: 32px;
          text-align: center;
        `"
        @click="imageUrl = ''"
      ></i> -->
    </div>
    <image-edit ref="imageEdit" @change="setImageUrl"></image-edit>
    <chose-from-vod @change="setImageUrl" ref="mediaVod"></chose-from-vod>
    <el-dialog
      title="添加方式选择"
      width="260px"
      :visible.sync="uploadMethod"
      append-to-body
    >
      <div style="display: flex">
        <el-button type="primary" :disabled="!power['查看']" @click="openVod"
          >媒资库导入</el-button
        >
        <el-button type="primary" style="margin-left: 10px" @click="choseFiles"
          >本地上传</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { uploadFile, saveFile } from "@/server/api/cos.js";
import showProgress from "@/components/uploadProgress/showProgress.vue";
import ImageEdit from "@/components/ImageEdit.vue";
import uuid from "uuid-js";
import ChoseFromVod from "@/components/choseFromVod/ChoseFromVod.vue";
// import { elementClosest } from "@fullcalendar/common";
import { BrowseIcon, DeleteIcon, Edit1Icon } from "tdesign-icons-vue";
import { getEditSign } from "@/server/api/cos.js";
export default {
  components: {
    showProgress,
    ImageEdit,
    ChoseFromVod,
    BrowseIcon,
    DeleteIcon,
    Edit1Icon,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "image",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "1:1",
    },
    isShowDel: {
      type: Boolean,
      default: true,
    },
    maxSize: {
      type: Number,
      default: 0,
    },
    fixedWidth: {
      type: Number,
      default: 0,
    },
    edit: {
      type: Boolean,
      default: true,
    },
    fileType: {
      type: String,
      default: "",
    },
    // mustEdit: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  watch: {
    // 监听 图片地址
    imageUrl: {
      handler(val) {
        console.log("图片地址变化了", val);
        this.$emit("uploadChange", val);
        this.$emit("input", val);
      },
      deep: true,
    },
    value: {
      handler(val) {
        if (val) {
          this.setImageUrl(val);
        } else {
          this.imageUrl = "";
        }
      },
    },
    disabled: {
      handler(val) {
        // console.log('禁用状态变化了',this.disabled)
        if (val) {
          this.showDelete = false;
          this.showEdit = false;
        } else {
          this.showDelete = true;
          this.showEdit = true;
        }
      },
    },
    isShowDel: {
      handler(val) {
        if (val === false) {
          this.showDelete = false;
        }
      },
    },
  },
  data() {
    return {
      pagID: "pag" + +new Date() + ((Math.random() * 1000).toFixed(0) + ""),
      imageUrl: "",
      currentFileType: "",
      scale: {},
      sliderStyle: {},
      height: "",
      width: "",
      dialogVisible: false,
      upload_name: "",
      showProgress: false,
      imgUrl: "",
      fileInfo: {},
      uploadMethod: false,
      power: {},
      error_img: false,
      showDelete: true,
      showEdit: true,
    };
  },
  mounted() {
    if (this.isShowDel == false) {
      this.showDelete = false;
    }
    if (this.disabled) {
      this.showDelete = false;
      this.showEdit = false;
    }
    this.power = this.utils.currentPower("媒体资源库管理");
    // 根据图片所需比例显示图片
    let wh = this.size.split(":"); //字符分割
    let fixedHeight = 0;
    if (wh[1] > 15) {
      fixedHeight = 400; //固定高度400px
    } else {
      fixedHeight = 200; //固定高度200px
    }
    let fixedWidth = Math.ceil((wh[0] / wh[1]) * fixedHeight);

    if (this.fixedWidth > 0) {
      fixedWidth = this.fixedWidth;
      fixedHeight = Math.ceil((wh[1] / wh[0]) * fixedWidth);
    }
    this.height = fixedHeight + "px";
    this.width = fixedWidth + "px";
    this.sliderStyle = {
      background: "#fff",
      width: fixedWidth + "px",
      height: fixedHeight + "px",
    };
    if (this.value) {
      this.setImageUrl(this.value);
    }
  },
  beforeDestroy() {
    // this.pagData.destroy();
  },

  methods: {
    //打开媒资库选择弹窗
    openVod() {
      this.$refs.mediaVod.openModal(this.type);
      this.uploadMethod = false;
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.data;
    },

    setImageUrl(image) {
      this.currentFileType = this.type;
      this.imageUrl = image;
      if (this.type == "image") {
        if (image.indexOf(".pag") != -1 || image.indexOf(".PAG") != -1) {
          this.currentFileType = "pag";
          this.setPagImage(this.imageUrl);
        }
      }
    },
    imgRequest() {
      return false;
    },

    getImageUrl() {
      return this.imageUrl;
    },
    choseFile() {
      if (this.disabled) {
        return;
      }
      if (this.power["查看"]) {
        this.uploadMethod = true;
      } else {
        this.choseFiles();
      }
    },
    choseFile1(e) {
      e.stopPropagation();
      // console.log("事件", e.target, e.target.nodeName);
      if (e.target.nodeName == "DIV") {
        if (this.disabled === true) {
          this.ShowImg(this.imageUrl, this.currentFileType);
        } else {
          this.choseFile();
        }
      }
    },
    showDetail() {
      this.ShowImg(this.imageUrl, this.currentFileType);
    },
    //COS前端上传
    choseFiles() {
      this.uploadMethod = false;
      let inputElem = document.createElement("input"); //创建文件选择
      let filetype = "";
      let type = this.type;
      if (type == "image") {
        filetype = ".jpg, .jpeg, .png, .gif, .webp, .pag";
      } else if (type == "audio") {
        filetype =
          ".aac, .adpcm, .amr, .dsd, .mp1, .mp2, .mp3, .pcm, .realaudio, .wma,";
      } else if (type == "video") {
        filetype = ".mp4,";
      } else if (type == "excel") {
        filetype = ".xls, .xlsx,";
      } else if (type == "directory") {
        inputElem.setAttribute("directory", "");
        inputElem.setAttribute("webkitdirectory", "");
      }
      if (this.fileType) {
        filetype = this.fileType;
      }
      // filetype = ".pdf, .txt, .jpeg, .png, .gif, .ico, .svg";
      inputElem.setAttribute("type", "file");
      if (filetype) {
        inputElem.setAttribute("accept", filetype);
      }
      inputElem.onchange = this.upload;
      inputElem.click();
    },
    upload(e) {
      // console.log("要上传的文件", test);
      let file = e.target.files[0];
      this.upload_name = uuid.create().hex;
      this.fileInfo = {
        name: file.name,
        size: file.size,
        type: this.type,
        file: file,
      };
      let uploadFileType = file.name
        .split(".")
        .splice(-1, 1)[0]
        .toLowerCase();
      if (this.type === "image") {
        if (this.fileType) {
          if (fileType.indexOf(uploadFileType) == -1) {
            this.info("只支持上传图片格式");
          }
        } else {
          const isImage =
            file.type === "image/jpeg" ||
            file.type === "image/png" ||
            file.type === "image/jpg" ||
            file.type === "image/webp" ||
            file.type === "image/gif" ||
            file.type === "";
          if (!isImage) {
            this.info("只支持上传图片格式");
            return;
          }
          console.log(file);
          if (file.name.indexOf(".pag") == -1) {
            this.imageCheck(file);
            return;
          } else {
            this.beginUpload(file);
          }
        }
        // this.imageCheck(file);
        // return;
      }
      if (this.type === "video") {
        if (file.type != "video/mp4") {
          this.info("只支持上传mp4视频文件");
          return;
        }
      }
      this.beginUpload(file);
    },
    //图片检查
    imageCheck(data) {
      if (data.size / 1024 / 1024 > 32) {
        this.info("图片大小不能超过32MB");
        return;
      }
      let that = this;
      let Url = "";
      // console.log(typeof data);
      if (typeof data == "object") {
        Url = URL.createObjectURL(data);
      } else {
        Url = data;
      }
      // console.log("Url", Url);
      let imgObj = new Image();
      console.log(imgObj);

      imgObj.onload = function() {
        window.URL.revokeObjectURL(Url);
        // console.log(imgObj);
        // console.log("宽", imgObj.width, "高", imgObj.height);
        if (imgObj.width > 30000 || imgObj.height > 30000) {
          that.info("上传图片宽高不能超过30000 x 30000");
        } else {
          console.log(data);
          that.beginUpload(data);
        }
      };
      imgObj.src = Url;
    },
    //开始上传
    beginUpload(file) {
      this.showProgress = true;
      uploadFile(file, this.upload_name).then((res) => {
        this.showProgress = false;
        if (res.status == "fail") {
          return;
        } else if (res.status == "success") {
          if (res.response.url.indexOf(".pag") != -1) {
            console.log("pag执行");
            this.currentFileType = "pag";
            this.setPagImage(res.response.url);
            return;
          }
          if (this.type == "image") {
            console.log("图片执行");
            if (this.edit) {
              this.$refs.imageEdit.showModal(res, this.fileInfo);
            } else {
              this.setImageUrl(res.response.url);
            }
          } else {
            this.setImageUrl(res.response.url);
          }
        }
      });
    },
    //pag
    setPagImage(urls) {
      this.imageUrl = urls;
      libpag.PAGInit().then((PAG) => {
        // 实例化成功
        const url = urls;
        fetch(url)
          .then((response) => response.blob())
          .then(async (blob) => {
            this.currentFileType = "pag";
            // console.log(blob);
            const file = new window.File(
              [blob],
              url.replace(/(.*\/)*([^.]+)/i, "$2")
            );
            const pagFile = await PAG.PAGFile.load(file);
            // document.getElementById("pag").width = pagFile.width();
            // document.getElementById("pag").height = pagFile.height();
            const pagView = await PAG.PAGView.init(pagFile, "#" + this.pagID);
            pagView.setRepeatCount(0);
            await pagView.play();
          });
      });
    },
    async changeImageUrl() {
      //如果地址不是cos地址则转存一次，不然不能编辑
      if (this.imageUrl.indexOf(".cos.") == -1) {
        await saveFile({url:this.imageUrl}).then((res) => {
          if (res.code === 0) {
            console.log("转存结果", res);
            this.imageUrl = res.data;
          }
        });
      }
      console.log(this.imageUrl);
      getEditSign(this.imageUrl).then((res) => {
        if (res.status == "success") {
          let end = res.response.url.indexOf("%3Fsmh-space%26");
          if (end == -1) {
            end = res.response.url.indexOf("%3Fsign%3D");
          }
          if (end == -1) {
            end = res.response.url.indexOf("?sign=q-sign-algorithm");
          }
          //中文名需要显示中文名pathName才能编辑，因为cos对中文名图片地址编码了两次
          res.response.opt.pathName = decodeURI(
            decodeURI(
              res.response.url.substring(
                res.response.url.indexOf("myqcloud.com") + 12,
                end
              )
            )
          );
          res.response.url = this.imageUrl;
          this.$refs.imageEdit.showModal(
            res,
            { name: "" },
            { source: "imageEdit" }
          );
        } else {
          this.warning("签名链接获取失败");
          console.log(res);
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.app-image-upload .avatar-uploader .el-upload {
  border: 1px solid #ced4da;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: block;
  width: 100%;
  height: 100%;
}

.app-image-upload .avatar-uploader {
  cursor: pointer;
  border: 1px solid #ced4da;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: block;
}

.app-image-upload .avatar-uploader .el-upload img {
  width: 100%;
  height: 100%;
}

.app-image-upload .avatar-uploader .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.transparent-bg {
  position: absolute;
  background-color: transparent;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}
</style>
<style lang="scss" scoped>
.upload-img-operate {
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  top: 0;
  left: 0;
  position: absolute;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}
.object-fit-cover {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
</style>
